import { Injectable } from '@angular/core';
import { AndroidPermissions } from '@ionic-native/android-permissions';

@Injectable()
export class AndroidPermissionsServiceProvider {

  constructor(
    public androidPermissions: AndroidPermissions
  ) { }
    
  checkPermission(permission: string) {
    return this.androidPermissions.checkPermission(permission);
  }

  requestPermission(permission: string) {
    return this.androidPermissions.requestPermission(permission);
  }

  requestPermissions(permission: string[]) {
    return this.androidPermissions.requestPermissions(permission);
  }
}



// WEBPACK FOOTER //
// ./src/providers/android-permissions/android-permissions.service.ts